import React from "react";
import PickerIcon from '@assets/tsx/icon/pickerIcon';
export default function Icon({ icon, size }) {
    if (!(icon === null || icon === void 0 ? void 0 : icon.iconClassName))
        return React.createElement("i", { className: "fas fa-question-circle" });
    return React.createElement("span", { className: +size !== 0 ? `ltg-icon--${+size + 1}x` : null },
        React.createElement(PickerIcon, Object.assign({}, icon)));
}
